import { cn as e } from "../utils/index.js";
import * as t from "react";
import { Fragment as n, jsx as r, jsxs as i } from "react/jsx-runtime";
import * as a from "recharts";
//#region src/components/chart.tsx
var o = {
	light: "",
	dark: ".dark"
}, s = t.createContext(null);
function c() {
	let e = t.useContext(s);
	if (!e) throw Error("useChart must be used within a <ChartContainer />");
	return e;
}
function l({ id: n, className: o, children: c, config: l, ...d }) {
	let f = t.useId(), p = `chart-${n || f.replace(/:/g, "")}`;
	return /* @__PURE__ */ r(s.Provider, {
		value: { config: l },
		children: /* @__PURE__ */ i("div", {
			"data-slot": "chart",
			"data-chart": p,
			className: e("[&_.recharts-cartesian-axis-tick_text]:fill-muted-foreground [&_.recharts-cartesian-grid_line[stroke='#ccc']]:stroke-border/50 [&_.recharts-curve.recharts-tooltip-cursor]:stroke-border [&_.recharts-polar-grid_[stroke='#ccc']]:stroke-border [&_.recharts-radial-bar-background-sector]:fill-muted [&_.recharts-rectangle.recharts-tooltip-cursor]:fill-muted [&_.recharts-reference-line_[stroke='#ccc']]:stroke-border flex aspect-video justify-center text-xs [&_.recharts-dot[stroke='#fff']]:stroke-transparent [&_.recharts-layer]:outline-hidden [&_.recharts-sector]:outline-hidden [&_.recharts-sector[stroke='#fff']]:stroke-transparent [&_.recharts-surface]:outline-hidden", o),
			...d,
			children: [/* @__PURE__ */ r(u, {
				id: p,
				config: l
			}), /* @__PURE__ */ r(a.ResponsiveContainer, { children: c })]
		})
	});
}
var u = ({ id: e, config: t }) => {
	let n = Object.entries(t).filter(([, e]) => e.theme || e.color);
	return n.length ? /* @__PURE__ */ r("style", { dangerouslySetInnerHTML: { __html: Object.entries(o).map(([t, r]) => `
${r} [data-chart=${e}] {
${n.map(([e, n]) => {
		let r = n.theme?.[t] || n.color;
		return r ? `  --color-${e}: ${r};` : null;
	}).join("\n")}
}
`).join("\n") } }) : null;
}, d = a.Tooltip;
function f({ active: a, payload: o, className: s, indicator: l = "dot", hideLabel: u = !1, hideIndicator: d = !1, label: f, labelFormatter: p, labelClassName: m, formatter: g, color: _, nameKey: v, labelKey: y }) {
	let { config: b } = c(), x = t.useMemo(() => {
		if (u || !o?.length) return null;
		let [t] = o, n = h(b, t, `${y || t?.dataKey || t?.name || "value"}`), i = !y && typeof f == "string" ? b[f]?.label || f : n?.label;
		return p ? /* @__PURE__ */ r("div", {
			className: e("font-medium", m),
			children: p(i, o)
		}) : i ? /* @__PURE__ */ r("div", {
			className: e("font-medium", m),
			children: i
		}) : null;
	}, [
		f,
		p,
		o,
		u,
		m,
		b,
		y
	]);
	if (!a || !o?.length) return null;
	let S = o.length === 1 && l !== "dot";
	return /* @__PURE__ */ i("div", {
		className: e("border-border/50 bg-background grid min-w-[8rem] items-start gap-1.5 rounded-lg border px-2.5 py-1.5 text-xs shadow-xl", s),
		children: [S ? null : x, /* @__PURE__ */ r("div", {
			className: "grid gap-1.5",
			children: o.filter((e) => e.type !== "none").map((t, a) => {
				let o = h(b, t, `${v || t.name || t.dataKey || "value"}`), s = _ || t.payload.fill || t.color;
				return /* @__PURE__ */ r("div", {
					className: e("[&>svg]:text-muted-foreground flex w-full flex-wrap items-stretch gap-2 [&>svg]:h-2.5 [&>svg]:w-2.5", l === "dot" && "items-center"),
					children: g && t?.value !== void 0 && t.name ? g(t.value, t.name, t, a, t.payload) : /* @__PURE__ */ i(n, { children: [o?.icon ? /* @__PURE__ */ r(o.icon, {}) : !d && /* @__PURE__ */ r("div", {
						className: e("shrink-0 rounded-[2px] border-(--color-border) bg-(--color-bg)", {
							"h-2.5 w-2.5": l === "dot",
							"w-1": l === "line",
							"w-0 border-[1.5px] border-dashed bg-transparent": l === "dashed",
							"my-0.5": S && l === "dashed"
						}),
						style: {
							"--color-bg": s,
							"--color-border": s
						}
					}), /* @__PURE__ */ i("div", {
						className: e("flex flex-1 justify-between leading-none", S ? "items-end" : "items-center"),
						children: [/* @__PURE__ */ i("div", {
							className: "grid gap-1.5",
							children: [S ? x : null, /* @__PURE__ */ r("span", {
								className: "text-muted-foreground",
								children: o?.label || t.name
							})]
						}), t.value && /* @__PURE__ */ r("span", {
							className: "text-foreground font-mono font-medium tabular-nums",
							children: t.value.toLocaleString()
						})]
					})] })
				}, t.dataKey);
			})
		})]
	});
}
var p = a.Legend;
function m({ className: t, hideIcon: n = !1, payload: a, verticalAlign: o = "bottom", nameKey: s }) {
	let { config: l } = c();
	return a?.length ? /* @__PURE__ */ r("div", {
		className: e("flex items-center justify-center gap-4", o === "top" ? "pb-3" : "pt-3", t),
		children: a.filter((e) => e.type !== "none").map((t) => {
			let a = h(l, t, `${s || t.dataKey || "value"}`);
			return /* @__PURE__ */ i("div", {
				className: e("[&>svg]:text-muted-foreground flex items-center gap-1.5 [&>svg]:h-3 [&>svg]:w-3"),
				children: [a?.icon && !n ? /* @__PURE__ */ r(a.icon, {}) : /* @__PURE__ */ r("div", {
					className: "h-2 w-2 shrink-0 rounded-[2px]",
					style: { backgroundColor: t.color }
				}), a?.label]
			}, t.value);
		})
	}) : null;
}
function h(e, t, n) {
	if (typeof t != "object" || !t) return;
	let r = "payload" in t && typeof t.payload == "object" && t.payload !== null ? t.payload : void 0, i = n;
	return n in t && typeof t[n] == "string" ? i = t[n] : r && n in r && typeof r[n] == "string" && (i = r[n]), i in e ? e[i] : e[n];
}
//#endregion
export { l as ChartContainer, p as ChartLegend, m as ChartLegendContent, u as ChartStyle, d as ChartTooltip, f as ChartTooltipContent };
